export function toSlug(text: string): string {
    return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/gi, "d")
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
}

export function shouldAutoGenerateSlug(
    isExistingArticle: boolean,
    slugManuallyEdited: boolean
): boolean {
    return !isExistingArticle && !slugManuallyEdited;
}
